const geocodeByAddress = (address) => {
  const geocoder = new window.google.maps.Geocoder()
  const { OK } = window.google.maps.GeocoderStatus

  return new Promise((resolve, reject) => {
    geocoder.geocode({ address }, (results, status) => {
      if (status !== OK) {
        return reject(status)
      }
      return resolve(results)
    })
  })
}

const getLatLng = (result) =>
  new Promise((resolve, reject) => {
    try {
      const latLng = {
        lat: result.geometry.location.lat(),
        lng: result.geometry.location.lng(),
      }
      return resolve(latLng)
    } catch (e) {
      return reject(e)
    }
  })

const geocodeByPlaceId = (placeId) => {
  const geocoder = new window.google.maps.Geocoder()
  const { OK } = window.google.maps.GeocoderStatus

  return new Promise((resolve, reject) => {
    geocoder.geocode({ placeId }, (results, status) => {
      if (status !== OK) {
        return reject(status)
      }
      return resolve(results)
    })
  })
}

const formatGoogleResult = (result) => {
  const location = {
    latitude: result.geometry.location.lat(), // mandatory
    longitude: result.geometry.location.lng(), // mandatory
    google_place_id: result.place_id,
    formatted_address: result.formatted_address,
    street_number: '',
    route: '',
    postal_code: '',
    locality: '',
    area_level_1: '',
    area_level_2: '',
    country: '', // mandatory
    country_short: '', // mandatory
  }
  for (let i = result.address_components.length - 1; i >= 0; i--) {
    const value = result.address_components[i].long_name
    const { types } = result.address_components[i]
    if (types.includes('street_number')) {
      // street_number
      location.street_number = value
    } else if (types.includes('postal_code')) {
      // postal_code
      location.postal_code = value
    } else if (types.includes('route')) {
      // route
      location.route = value
    } else if (types.includes('locality')) {
      // locality
      location.locality = value
    } else if (types.includes('country')) {
      // country
      location.country = value
      location.country_short = result.address_components[i].short_name
    } else if (types.includes('area_level_1')) {
      // area_level_1
      location.area_level_1 = value
    } else if (types.includes('area_level_2')) {
      // area_level_2
      location.area_level_2 = value
    }
  }
  return location
}

export { geocodeByAddress, getLatLng, geocodeByPlaceId, formatGoogleResult }
